const OBJECT_ID = /^[0-9a-f]{24}$/i;
const URI_RE = /^terakki:\/\/group\/([0-9a-f]{24})\/template\/([0-9a-f]{24})$/i;

export function parseJoinCode(input) {
  if (typeof input !== "string") return null;
  const trimmed = input.trim();
  if (!trimmed) return null;

  const uriMatch = trimmed.match(URI_RE);
  if (uriMatch) {
    return { groupId: uriMatch[1], templateId: uriMatch[2] };
  }

  if (trimmed.startsWith("{")) {
    try {
      const obj = JSON.parse(trimmed);
      const { groupId, templateId } = obj || {};
      if (
        typeof groupId === "string" &&
        typeof templateId === "string" &&
        OBJECT_ID.test(groupId) &&
        OBJECT_ID.test(templateId)
      ) {
        return { groupId, templateId };
      }
    } catch (_) {
      return null;
    }
  }

  return null;
}
